import { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import type { Contact } from '../models/Contact';

export const ADD_CONTACT_MUTATION: TypedDocumentNode<{ added: boolean, }, { input: Contact }> = gql`
  mutation AddContact($input: ContactModelInput!) {
    added: addContact(input: $input)
  }
`;

export const UPDATE_CONTACT_MUTATION: TypedDocumentNode<{ updatedContact: Contact }, { id: number, input: Contact }> = gql`
  mutation UpdateContact($id: Int!, $input: ContactModelInput!) {
    updatedContact: updateContact(id: $id, input: $input) {
      name,
      email,
      phone
    }
  }
`;

export const DELETE_CONTACT_BY_ID_MUTATION: TypedDocumentNode<{ deleted: boolean }, { id: number }> = gql`
  mutation DeleteContactById($id: Int!) {
    deleted: deleteContactById(id: $id)
  }
`;

